import * as React from "react";
import axios from 'axios';
import CheckBox from "../../Checkbox";
import EditableHeading from '../../EditableHeading';
import Icon from '../../../icons';
import { getAuthHeaders } from '../../../utils/authManager';
import { downloadFile, formatSizeInKB } from '@/common/util';

const PREVIEW_HEIGHT = 500;
const PREVIEW_WIDTH = 500;

function fetchPreview(guid) {
  return axios.get(`${process.env.core_gateway_url}/1.0/preview`, {
    headers: getAuthHeaders(),
    params: { guid, height: PREVIEW_HEIGHT, width: PREVIEW_WIDTH },
    responseType: 'blob',
  });
}

 export default class ImageTemplate extends React.Component {
    EditableHeading;
    checkBoxChange;
    objectUrl;
    constructor(props) {
        super(props);
        this.state={
            isOpen:false,
            checkboxValue:false,
            EditableMode:true,
            viewer:false,
            previewSrc:null,
        }
        this.handleCheckboxChange=this.handleCheckboxChange.bind(this);
        this.handleDisplayViewer=this.handleDisplayViewer.bind(this);
        this.handleDownloadClick=this.handleDownloadClick.bind(this);
    }

    componentDidMount(){
        if(this.props.data.CanModifyCaption){
            this.setState({
                EditableMode:this.props.data.CanModifyCaption
            })
        }
        else{
            this.setState({
                EditableMode:this.props.EditableMode
            })
        }
        this.loadPreview();
    }

    componentDidUpdate(prevProps){
        if(prevProps.data.FileGuid !== this.props.data.FileGuid){
            this.loadPreview();
        }
    }

    componentWillUnmount(){
        if(this.objectUrl){
            window.URL.revokeObjectURL(this.objectUrl);
        }
    }

    loadPreview(){
        const guid = this.props.data.FileGuid;
        if(!guid) return;
        fetchPreview(guid)
            .then((response) => {
                this.objectUrl = window.URL.createObjectURL(response.data);
                this.setState({ previewSrc: this.objectUrl });
            })
            .catch(() => {});
    }

    UNSAFE_componentWillReceiveProps(newProps){
        if(newProps.isSelectAll !== this.props.isSelectAll){
            this.setState({
                checkboxValue: newProps.extraData.selectedFiles && newProps.extraData.selectedFiles.length > 0 && newProps.extraData.selectedFiles.filter(file => file.FileGuid === newProps.data.FileGuid).length > 0
            })
        }
    }

    handleCheckboxChange(e,file){
        this.setState({
            checkboxValue:(!this.state.checkboxValue )
        })
        this.props.handleSelectAllShow(!e.checked,file);
    }

    async handleDownloadClick(e){
        e.preventDefault();
        const imageData = this.props.data;
        try{
            await downloadFile(imageData.FileGuid, imageData.FileName);
        } catch(error){
            console.log(error);
        }
    }

    handleDisplayViewer(){
        // Thumbnail src is a blob url, so identify the selected image by its guid
        const currentSelected = this.props.data.FileGuid || '';
        this.setState({
            viewer:true
        },()=>{
            this.props.handleDisplayViewer(this.state.viewer, currentSelected)
        })
    }

    render() {
        const imageData=this.props.data;
        let TruncateFileName = this.props.truncateFileName(imageData.FileName);        
        return (
                <div className="fileAttachment imageTemplate flexGrow">
                    <div className="flexGrow fileListing">
                        <div className="filesMain">
                            {this.state.previewSrc
                                ? <img className={`${this.props.galleryData && this.props.galleryData.length ? 'pointer':''}`} src={this.state.previewSrc} onClick={this.props.galleryData && this.props.galleryData.length ? this.handleDisplayViewer : ()=>{return false}}/>
                                : <Icon name="thumbnail" className="icon" />
                            }
                        </div>
                        <div className="fileInfo">
                            {
                                (imageData.IsMultiDownload) ?
                                <div className="checkboxArea" >
                                    <CheckBox item={{id:(imageData.NoteId ||'') + imageData.FileGuid,checked:this.state.checkboxValue}}
                                    handleCheckbox={(event)=>this.handleCheckboxChange(event,imageData)} 
                                    ref={ref=>this.checkBoxChange=ref}/>
                                </div>
                                : null
                            }

                            <span className="fileName quickTooltip-bottom" data-quicktooltip={this.props.isPrintPreview ? null: imageData.FileName}>
                                {
                                    (imageData.FileGuid && !this.props.isPrintPreview) ?  <a className="downloadLink" href="javascript:void(0)" onClick={this.handleDownloadClick}>{TruncateFileName} ({formatSizeInKB(imageData.FileSize)}) <Icon name="download" className="icon ml" /></a> : <span>{TruncateFileName} ({imageData.FileSize})</span>
                                }
                            </span>
                            {
                                (this.state.EditableMode && !this.props.isPrintPreview) ?
                                <span>
                                    <div className="inlineEditor">
                                        <EditableHeading
                                            heading={(imageData.Caption !== null && imageData.Caption.trim() == "") ? '' : imageData.Caption}
                                            onHeadingEdited={this.props.handleSaveCaption}
                                            maxLength={180}
                                            id={imageData}
                                            // isOpen={this.state.isOpen}
                                            ListingComponent={true}
                                            //showEditButton={(imageData.Caption !== null && imageData.Caption.trim() == "") ? false : true}
                                            ref={editable => this.EditableHeading = editable}
                                        />
                                    </div>
                                    <div className="fileAction">
                                        {(imageData.Caption == null || imageData.Caption.trim() == "") ? null : <React.Fragment><a  href="javascript:void(0)" onClick={()=>{ this.EditableHeading.onEditClick()}} className="mr__1">Edit</a>
                                        <a className="deleteCaption" onClick={()=>this.props.handleDeleteCaption(imageData)}>Delete</a></React.Fragment>}
                                    </div>
                                </span>
                                :
                                <div className="fileNameDisplay">{imageData.Caption}</div>
                            }
                        </div>
                    </div>
                </div>
        )
    }
}

